module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/plug.svg?7d44c5162ca77405122ce4345086c9cd";